import * as React from "react"

function Play(props) {
    return <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect width="36" height="36" rx="18" fill="black" fill-opacity="0.7" />
        <path d="M25.5 18L12.75 25.7942L12.75 10.2058L25.5 18Z" fill="#D7DEE6" />
    </svg>

}

export default Play
